import { createElement, forwardRef } from 'react'

const component = variant => forwardRef(({
    font, red, black, primary, color, alt, bold, weight, underline, italic, small,
    noWrap, lineHeight, align, size, overflow, opacity, spacing, transform, decoration, uppercase,
    fullWidth, maxWidth, maxHeight, maxLines, zIndex, mt, mb, style, className, children, ...props
}, ref) => {
  return createElement(variant, {
    ref,
    className: `${className || ''}${small ? ' small' : ''}`,
    style: {
      ...(font && { fontFamily: font }),
      ...((red || black || primary || color) && {
        color: color || (red && 'var(--red)') || (black && 'var(--black)') || (primary && 'var(--primary)')
      }),
      ...(alt && { fontFamily: 'var(--font-alternate)', textTransform: 'none' }),
      ...(noWrap && { whiteSpace: 'nowrap' }),
      ...(lineHeight && { lineHeight }),
      ...(align && { textAlign: align }),
      ...((bold !== undefined || weight) && { fontWeight: bold ? 'bold' : (weight || 400) }),
      ...(size && { fontSize: size }),
      ...(overflow && { overflow: overflow === 'ellipsis' ? 'hidden' : overflow }),
      ...(overflow === 'ellipsis' && { textOverflow: 'ellipsis', maxWidth: '100%' }),
      ...(maxLines && { display: '-webkit-box', WebkitLineClamp: maxLines, WebkitBoxOrient: 'vertical', overflow: 'hidden' }),
      ...(fullWidth && { width: '100%' }),
      ...(maxWidth && { maxWidth }),
      ...(maxHeight && { maxHeight }),
      ...(opacity !== undefined && { opacity }),
      ...(spacing !== undefined && { letterSpacing: spacing }),
      ...((transform !== undefined || uppercase) && { textTransform: `${transform ? transform : ''}${uppercase ? ' uppercase' : ''}` }),
      ...(decoration !== undefined && { textDecoration: decoration }),
      ...(zIndex !== undefined && { zIndex }),
      ...(mt !== undefined && { marginTop: mt }),
      ...(mb !== undefined && { marginBottom: mb }),
      ...(underline && { textDecoration: 'underline' }),
      ...(italic && { fontStyle: 'italic' }),
      ...style
    },
    children,
    ...props
  })
})

export const H1 = component('h1')
export const H2 = component('h2')
export const H3 = component('h3')
export const H4 = component('h4')
export const H5 = component('h5')
export const H6 = component('h6')
export const Body = component('span')
export const P = component('p')

